export const locale = {
  text: 'Due to inactivity your session is about to expire. Do you want to extend your session?',
  header: 'Still with us?',
  signout: 'No, sign out',
  extend: 'Extend session',
};
